
import api from '~/plugins/api'
import { mapState } from 'vuex'
import { checkMobile, checkEmail } from '~/plugins/util'
export default {
  name: 'aboutpage',
  computed: {
    ...mapState({
      // cloundList: state => state.cloundList,
    })
  },
  head() {
    return {
      title: '联系我们',
      meta: [{
        hid: "about page",
        name: "description",
        content: "不忘初心联系我们"
      }]
    }
  },
  data() {
    return {
      name: '',
      phone: '',
      email: '',
      content: ''
    };
  },
  watch: {
  },
  async fetch({ store, $axios }) {
  },
  mounted() {
    this.$store.commit('setNavWhite', true);
  },
  methods: {
    toSubmit() {
      if(!this.name) return this.$message.warning('请输入您的姓名！');
      if(!this.phone) return this.$message.warning('请输入您的电话！');
      if(!checkMobile(this.phone)) return this.$message.warning('电话格式有误！');
      if(!this.email) return this.$message.warning('请输入您的邮箱！');
      if(!checkEmail(this.email)) return this.$message.warning('邮箱格式有误！');
      if(!this.content) return this.$message.warning('请输入内容！');

      this.$axios.$post(api.addContact, {
        truename: this.name,
        mobile: this.phone,
        email: this.email,
        content: this.content
       })
      .then(data => {
        this.name = '';
        this.phone = '';
        this.email = '';
        this.content = '';
        this.$message.success('感谢您的留言，我们将尽快反馈您！')
      }).catch(err => {
        this.$message.error(err || '啊哦，网络走丢啦~请稍后再试！')
      })
    }
  },
  destroyed() {
    this.$store.commit('setNavWhite', false);
  }
};
